import styled from "styled-components";
import { DateRangePicker } from "react-date-range";

export const StyledDateRangePicker = styled(DateRangePicker)`
  .rdrDayStartPreview,
  .rdrDayEndPreview,
  .rdrDayInPreview,
  .rdrDayToday,
  .rdrStartEdge,
  .rdrInRange,
  .rdrEndEdge {
    color: var(--allie-color-primary-50) !important;
  }
  .rdrDayToday .rdrDayNumber span:after {
    background: var(--allie-color-primary-50) !important;
  }
`;
